<template>
  <b-form-group
    label="Kart Tipi"
    label-for="id_card_type"
  >
    <validation-provider
      #default="{ errors }"
      name="Kart Tipi"
      rules="required"
    >
      <v-select
        id="id_card_type"
        v-model="dataItem.id_card_type"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Kart Tipi"
        :clearable="false"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'CardType',
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['binsDefines/dataItem']
    },
    dataList() {
      return this.$store.getters['cardType/dataList']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('cardType/getDataList')
    },
  },
}
</script>
